import React from 'react';
import { MessageCircle, Phone, FileText, MapPin } from 'lucide-react';
import { CONTACT_INFO, WHATSAPP_MESSAGES } from '../data/mockData';

const MobileBottomBar = () => {
  const whatsappLink = `https://wa.me/${CONTACT_INFO.whatsapp}?text=${encodeURIComponent(WHATSAPP_MESSAGES.generic)}`;

  const actions = [
    {
      icon: MessageCircle,
      label: 'WhatsApp',
      href: whatsappLink,
      color: 'text-[#25D366]',
      external: true
    },
    {
      icon: Phone,
      label: 'Call',
      href: `tel:${CONTACT_INFO.phone}`,
      color: 'text-[#039fff]'
    },
    {
      icon: FileText,
      label: 'Quote',
      href: '#quote',
      color: 'text-[#fb6402]',
      scrollTo: true
    },
    {
      icon: MapPin,
      label: 'Track',
      href: '/track',
      color: 'text-[#001A47]'
    }
  ];

  const handleClick = (e, action) => {
    if (action.scrollTo) {
      e.preventDefault();
      const element = document.querySelector(action.href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="grid grid-cols-4 gap-0">
        {actions.map((action) => {
          const Icon = action.icon;
          const Component = action.external ? 'a' : 'a';
          
          return (
            <Component
              key={action.label}
              href={action.href}
              onClick={(e) => handleClick(e, action)}
              className="flex flex-col items-center justify-center py-3 hover:bg-gray-50 transition-colors"
              {...(action.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              <Icon className={`h-5 w-5 ${action.color} mb-1`} />
              <span className="text-xs text-gray-700 font-medium">{action.label}</span>
            </Component>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomBar;
